import React, {FunctionComponent} from "react";
import renderText from "../renderText";
import styles from "./comments.module.css";
import {iif} from "../iif";
import {IComment} from "../../services/types";
import getFontSize from "../../utils/getFontSize";
import {cssHelper} from "../../utils/cssHelper";
import icons from "../../styles/icons.module.css";
import numDigits from "../../utils/numDigits";
import i18n from "../../i18n";

interface CommentProps extends IComment {
    locale: string;
    isOwn: boolean;
    onReply: (commentId: number) => void;
    onRate: (commentId: number, rate: "up" | "down") => void;
}

export const Comment: FunctionComponent<CommentProps> = (props) => {
    const {createdOn, locale} = props;

    const date = createdOn.toLocaleDateString
            ? createdOn.toLocaleDateString(locale, { month: "long", day: "numeric" })
            : createdOn.toDateString();

    const maxActionLength = Math.max(
        i18n("comments.commentitem.like").length,
        i18n("comments.commentitem.dislike").length,
        i18n("comments.commentitem.reply").length
    );
    const fontSize = getFontSize(maxActionLength, 24, 32, 10, 16);
    const opacity = props.rating && props.rating < 0
        ? (10 - Math.min(-props.rating, 8)) / 10
        : 1;

    return (
        <div className={styles.comment} data-comment={props.id} style={{opacity}}>
            <div>
                <div className={styles.avatar} style={{ backgroundImage: `url('${props.user.image}')`}}/>
            </div>
            <div className={styles.comment_body}>
                <div className={styles.comment_header}>
                    <div className={styles.user_name} dangerouslySetInnerHTML={{__html: props.user.name}}/>
                    {renderText(date, 16, 22, 12, 20, styles.date)}
                </div>
                <div className={styles.text} dangerouslySetInnerHTML={{__html: props.text}}/>
            </div>

            <div className={styles.bottom_panel}>
                <div>
                    {iif(props.rating != null,
                        <div className={styles.rating}>
                            <i className={cssHelper(icons.icon).add(icons.like, props.rating! >= 0).add(icons.dislike, props.rating! < 0).toString()}/>
                            <span style={{ fontSize: getFontSize(numDigits(Math.abs(props.rating!)), 18, 32, 2, 6) }}>{Math.abs(props.rating!) + ""}</span>
                        </div>
                    )}
                    <button className={styles.action} style={{fontSize}} onClick={() => props.onRate(props.id, "up")} disabled={props.isOwn || props.rate! > 0}>{i18n("comments.commentitem.like")}</button>
                </div>
                <div>
                    <button className={styles.action} style={{fontSize}} onClick={() => props.onRate(props.id, "down")} disabled={props.isOwn || props.rate! < 0}>{i18n("comments.commentitem.dislike")}</button>
                </div>
                <div>
                    <button className={styles.action} style={{fontSize}} onClick={() => props.onReply(props.id)}>{i18n("comments.commentitem.reply")}</button>
                </div>
            </div>
        </div>
    );
};
